<div class="m-4">
  <h2 class="mb-4" i18n="@@close-order.confirm-cancel">Bekräfta avbeställning</h2>
  <p class="mb-5" i18n="@@close-order.cancel-information"> Vid avbeställning kommer pågående körorder avslutas och inga nya turer påbörjas. </p>

  <div class="d-flex">
    <button class="btn btn-outline-primary btn-min-width ms-auto me-2" id="dismissBtn" type="button" (click)="activeModal.dismiss()" [disabled]="buttonsDisabled" i18n="@@close-order.close">Stäng</button>
    <button class="btn btn-primary btn-min-width" id="cancelOrderBtn" type="button" (click)="closeOrder()" [disabled]="buttonsDisabled" i18n="@@close-order.confirm">Bekräfta</button>
  </div>
</div>
